var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { NewCaseComponent } from './../new-case/new-case.component';
import { QueryList } from '@angular/core';
import { ApiService } from '@app/utility/api.service';
import { UtilService } from '@app/utility/util.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
var ContactHistoryComponent = /** @class */ (function () {
    function ContactHistoryComponent(apiService, util) {
        this.apiService = apiService;
        this.util = util;
        this.contactId = "";
        this.viewCase = false;
        this.contactFullname = "";
        this.caseHistoryList = [];
        this.chatbotHistoryList = [];
        this.emailHistoryList = [];
        this.smsHistoryList = [];
        this.chatBotLastRow = [];
        this.role = {};
        this.isCheckedAll = false;
        this.agentList = [];
        this.userIdReceive = "";
        this.userList = [];
        this.forwardRemark = "";
        this.submittedForward = false;
        this.cancelRemark = "";
        this.submittedCancel = false;
        this.emailAndSmsDetail = {};
    }
    ContactHistoryComponent.prototype.ngOnInit = function () {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs;
            return __generator(this, function (_a) {
                thisTs = this;
                //await this.init("")
                $(".select2").select2();
                $("#userIdReceiveHistory").on("change", function () {
                    thisTs.userIdReceive = $("#userIdReceiveHistory").find('option:selected').val();
                });
                return [2 /*return*/];
            });
        });
    };
    ContactHistoryComponent.prototype.init = function (id, fullname) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(this.contactId == "")) return [3 /*break*/, 2];
                        this.contactId = id;
                        this.contactFullname = fullname;
                        this.cookieData = JSON.parse(localStorage.getItem("dpa_cc"));
                        this.role = JSON.parse(this.cookieData.role);
                        this.myTeams = JSON.parse(this.cookieData.teams);
                        return [4 /*yield*/, this.callApi()
                            //await this.searchCase()
                        ];
                    case 1:
                        _a.sent();
                        //await this.searchCase()
                        console.log("history on init");
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ContactHistoryComponent.prototype.callApi = function () {
        return forkJoin([
            this.searchCase(),
            this.searchChatbot(),
            this.searchEmail(),
            this.searchSMS(),
            this.initDropdown()
        ]);
    };
    ContactHistoryComponent.prototype.createCase = function () {
        return __awaiter(this, void 0, void 0, function () {
            var url;
            return __generator(this, function (_a) {
                url = this.util.baseUrl() + "/newCaseForContact/" + this.contactId;
                window.open(url, '_blank');
                return [2 /*return*/];
            });
        });
    };
    ContactHistoryComponent.prototype.initDropdown = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a, _b, _c, para, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("master", "caseStatus")];
                    case 1:
                        _a.caseStatusList = _e.sent();
                        _b = this;
                        return [4 /*yield*/, this.apiService.get("master", "caseSubTypeDetail")];
                    case 2:
                        _b.subTypeDetailTmpList = _e.sent();
                        _c = this;
                        return [4 /*yield*/, this.apiService.get("master", "callcenterTeam")
                            // this.teamList = teams.filter((t: any) => {
                            //   return this.myTeams.map((mt: any) => { return mt.dpa_callcenterteamid }).indexOf(t.dpa_callcenterteamid) > -1
                            // })
                        ];
                    case 3:
                        _c.teamList = _e.sent();
                        para = "";
                        this.teamList.forEach(function (t) {
                            if (para != "") {
                                para += "&";
                            }
                            para += "callcenterteam=" + t.dpa_callcenterteamid;
                        });
                        _d = this;
                        return [4 /*yield*/, this.apiService.get("crmservice", "callcenterProfile", para)];
                    case 4:
                        _d.agentList = _e.sent();
                        this.searchEmail();
                        this.searchSMS();
                        return [2 /*return*/];
                }
            });
        });
    };
    ContactHistoryComponent.prototype.delete = function () {
        this.getSelectedContact();
        if (this.selectList.length < 1) {
            this.util.WarningDialog("กรุณาเลือกอย่างน้อย 1 รายการ");
        }
        else {
            $("#deleteModal").modal('show');
        }
    };
    ContactHistoryComponent.prototype.forward = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var inValidStatus, caseForward_1, caseForwardSubTypeDetail_1, matchTeam, matchUser, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.getSelectedContact();
                        if (!(this.selectList.length != 1)) return [3 /*break*/, 1];
                        this.util.WarningDialog("กรุณาเลือก 1 รายการ");
                        return [3 /*break*/, 9];
                    case 1:
                        inValidStatus = this.selectList.filter(function (s) {
                            return s.status != null && s.status.toLowerCase() != "new" && s.status.toLowerCase() != "inprogress";
                        });
                        if (inValidStatus != null && inValidStatus.length > 0) {
                            this.util.WarningDialog("กรุณาเลือกเฉพาะรายการที่มีสถานะเป็น New หรือ Inprogress เท่านั้น");
                            return [2 /*return*/];
                        }
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 6, , 8]);
                        caseForward_1 = this.caseHistoryList.filter(function (c) {
                            return c.incidentid == _this.selectList[0].caseId;
                        });
                        caseForwardSubTypeDetail_1 = this.subTypeDetailTmpList.filter(function (st) {
                            return st.dpa_casesubtypedetailid == caseForward_1[0].dpa_casesubtypedetailid;
                        });
                        matchTeam = this.teamList.filter(function (t) {
                            return t.dpa_callcenterteamid == caseForwardSubTypeDetail_1[0].dpa_teamownerid;
                        });
                        if (!(matchTeam != null && matchTeam.length > 0)) return [3 /*break*/, 4];
                        this.forwardTeam = caseForwardSubTypeDetail_1[0].dpa_teamownerid;
                        return [4 /*yield*/, this.onForwardTeamChange()];
                    case 3:
                        _a.sent();
                        matchUser = this.userList.filter(function (u) {
                            return u.dpa_customwebuserid == caseForwardSubTypeDetail_1[0].dpa_caseownerid;
                        });
                        if (matchUser != null && matchUser.length > 0) {
                            this.userIdReceive = caseForwardSubTypeDetail_1[0].dpa_caseownerid;
                        }
                        else {
                            this.userIdReceive = "";
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        this.forwardTeam = "";
                        _a.label = 5;
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_1 = _a.sent();
                        console.log("ไม่สามารถกำหนดค่าเริ่มต้นได้");
                        this.forwardTeam = "";
                        return [4 /*yield*/, this.onForwardTeamChange()];
                    case 7:
                        _a.sent();
                        this.userIdReceive = "";
                        return [3 /*break*/, 8];
                    case 8:
                        this.submittedForward = false;
                        this.forwardRemark = "";
                        $("#forwardInHistoryModal").modal('show');
                        _a.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    ContactHistoryComponent.prototype.CloseModal = function (modalID) {
        $("#" + modalID).modal("hide");
    };
    ContactHistoryComponent.prototype.confirmForward = function () {
        return __awaiter(this, void 0, void 0, function () {
            var success, fail, caseId_1, req, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submittedForward = true;
                        success = 0, fail = 0;
                        if (!(this.forwardTeam != null && this.forwardTeam.trim() != "" && this.forwardRemark != null && this.forwardRemark.trim() != "")) return [3 /*break*/, 2];
                        this.util.ShowWaiting(true);
                        caseId_1 = this.selectList[0].caseId;
                        req = this.caseHistoryList.filter(function (c) {
                            return c.incidentid == caseId_1;
                        });
                        req[0].customerid = this.contactId;
                        req[0].dpa_modifiedby = this.cookieData.userId;
                        req[0].dpa_owningteamid = this.forwardTeam;
                        req[0].dpa_caseowner = this.userIdReceive;
                        req[0].dpa_assignby = this.cookieData.userId;
                        return [4 /*yield*/, this.apiService.put("crmservice", "caseIncident-share/" + caseId_1, req[0])];
                    case 1:
                        res = _a.sent();
                        if (this.util.isSuccessResponse(res)) {
                            $("#forwardInHistoryModal").modal('hide');
                            this.util.SuccessDialog("ส่งต่อ Case สำเร็จ");
                        }
                        else {
                            this.util.ErrorDialog("ส่งต่อ Case ไม่สำเร็จ");
                        }
                        this.util.ShowWaiting(false);
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ContactHistoryComponent.prototype.confirmDelete = function () {
        return __awaiter(this, void 0, void 0, function () {
            var success, fail, cancelStatus, _loop_1, this_1, res, i;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.submittedCancel = true;
                        if (!(this.cancelRemark.trim() != "")) return [3 /*break*/, 6];
                        this.util.ShowWaiting(true);
                        success = 0, fail = 0;
                        cancelStatus = this.caseStatusList.filter(function (c) {
                            return c.dpa_name != null && c.dpa_name.toLowerCase().trim() == "cancel";
                        });
                        if (cancelStatus == null || cancelStatus.length == 0) {
                            this.util.ErrorDialog("ไม่สามารถดึงค่าสถานะยกเลิกได้ กรุณาติดต่อเจ้าหน้าที่");
                            return [2 /*return*/];
                        }
                        _loop_1 = function (i) {
                            var caseId, req;
                            return __generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        caseId = this_1.selectList[i].caseId;
                                        req = this_1.caseHistoryList.filter(function (c) {
                                            return c.incidentid == caseId;
                                        });
                                        req[0].customerid = this_1.selectList[i].customerId;
                                        req[0].dpa_modifiedby = this_1.cookieData.userId;
                                        req[0].dpa_casestatusid = cancelStatus[0].dpa_casestatusid;
                                        req[0].dpa_remark = this_1.cancelRemark;
                                        return [4 /*yield*/, this_1.apiService.put("crmservice", "caseIncident/" + caseId, req[0])];
                                    case 1:
                                        res = _a.sent();
                                        if (this_1.util.isSuccessResponse(res)) {
                                            ++success;
                                        }
                                        else {
                                            ++fail;
                                        }
                                        return [2 /*return*/];
                                }
                            });
                        };
                        this_1 = this;
                        i = 0;
                        _a.label = 1;
                    case 1:
                        if (!(i < this.selectList.length)) return [3 /*break*/, 4];
                        return [5 /*yield**/, _loop_1(i)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        i++;
                        return [3 /*break*/, 1];
                    case 4:
                        //some case fail some case success
                        if (fail > 0 && success > 0) {
                            this.util.WarningDialog("ลบสำเร็จจำนวน: " + success + " เคส, ลบไม่สำเร็จจำนวน: " + fail + " เคส");
                        }
                        else if (fail == 0 && success == 0) {
                            this.util.ErrorDialog("ลบ Case ไม่สำเร็จ");
                        }
                        else if (fail > 0 && success == 0) {
                            this.util.ErrorDialog("ลบ Case ไม่สำเร็จ");
                        }
                        else {
                            $("#deleteModal").modal('hide');
                            this.util.SuccessDialog("ลบ Case สำเร็จ");
                        }
                        return [4 /*yield*/, this.searchCase()];
                    case 5:
                        _a.sent();
                        this.util.ShowWaiting(false);
                        _a.label = 6;
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ContactHistoryComponent.prototype.searchCase = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, caseList;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.caseHistoryList = [];
                        para = "contactid=" + this.contactId;
                        return [4 /*yield*/, this.apiService.get("crmservice", "caseIncident", para)];
                    case 1:
                        caseList = _a.sent();
                        this.caseHistoryList = caseList.filter(function (c) {
                            return c.dpa_casestatuscode != null && c.dpa_casestatuscode != "04";
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ContactHistoryComponent.prototype.searchChatbot = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.chatbotHistoryList = [];
                        para = "contactid=" + this.contactId;
                        $('#tbCase').DataTable().clear().destroy();
                        return [4 /*yield*/, this.apiService.get("crmservice", "chatbot", para)];
                    case 1:
                        tmp = _a.sent();
                        this.chatBotLastRow = [];
                        if (tmp != null && tmp.data != null && tmp.data.length > 0) {
                            this.chatbotHistoryList = tmp.data;
                            this.chatBotLastRow.push(tmp.data[tmp.data.length - 1]);
                        }
                        else {
                            this.chatbotHistoryList = [];
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ContactHistoryComponent.prototype.searchEmail = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        para = "channel=1&contactid=" + this.contactId;
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("crmservice", "activityHistory", para)
                            //this.emailHistoryList = []
                        ];
                    case 1:
                        _a.emailHistoryList = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ContactHistoryComponent.prototype.searchSMS = function () {
        return __awaiter(this, void 0, void 0, function () {
            var para, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        para = "channel=2&contactid=" + this.contactId;
                        _a = this;
                        return [4 /*yield*/, this.apiService.get("crmservice", "activityHistory", para)
                            //this.smsHistoryList = []
                        ];
                    case 1:
                        _a.smsHistoryList = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ContactHistoryComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        this.tbCase.changes.subscribe(function (t) {
            _this.initTableCase();
        });
        this.tbChatbot.changes.subscribe(function (t) {
            _this.initTableChatbot();
        });
        this.tbEmail.changes.subscribe(function (t) {
            _this.initTableEmail();
        });
        this.tbSMS.changes.subscribe(function (t) {
            _this.initTableSms();
        });
    };
    ContactHistoryComponent.prototype.ngForRendred = function () {
        console.log('NgFor is Rendered');
        if (this.dtC == null) {
            this.initTableCase();
        }
        if (this.dtB == null) {
            this.initTableChatbot();
        }
        if (this.dtE == null) {
            this.initTableEmail();
        }
        if (this.dtS == null) {
            this.initTableSms();
        }
    };
    ContactHistoryComponent.prototype.initTableCase = function () {
        return __awaiter(this, void 0, void 0, function () {
            var thisTs;
            return __generator(this, function (_a) {
                thisTs = this;
                $("#tbCase td:not(.checkbox-col)").on("click", function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var url;
                        return __generator(this, function (_a) {
                            url = thisTs.util.baseUrl() + "/caseDetail/" + $(this).parent('tr')[0].id;
                            window.open(url, "_blank");
                            return [2 /*return*/];
                        });
                    });
                });
                return [2 /*return*/];
            });
        });
    };
    ContactHistoryComponent.prototype.initTableChatbot = function () {
        $("#tbChatbot tbody tr").on("click", function () {
            $("#chatbotHistoryModal").modal('show');
        });
        // this.dtB = $("#tbChatbot").dataTable({
        //   retrieve: true,
        //   'paginate': false
        // });
    };
    ContactHistoryComponent.prototype.initTableEmail = function () {
        var thisTs = this;
        $("#tbEmail tbody tr").on("click", function () {
            var _this = this;
            var email = thisTs.emailHistoryList.filter(function (e) {
                return e.dpa_activityhistoryid == _this.id && e.dpa_channel == 1;
            });
            if (email == null || email.length == 0) {
                thisTs.util.ErrorDialog("ไม่สามารถดึงข้อมูลได้ กรุณาติดต่อเจ้าหน้าที่");
                return;
            }
            thisTs.emailAndSmsDetail = email[0];
            $("#emailHistoryModal").modal('show');
        });
        // this.dtE = $("#tbEmail").dataTable({
        //   retrieve: true,
        //   'paginate': false
        // });
    };
    ContactHistoryComponent.prototype.initTableSms = function () {
        var thisTs = this;
        $("#tbSMS tbody tr").on("click", function () {
            var _this = this;
            var sms = thisTs.smsHistoryList.filter(function (s) {
                return s.dpa_activityhistoryid == _this.id && s.dpa_channel == 2;
            });
            if (sms == null || sms.length == 0) {
                thisTs.util.ErrorDialog("ไม่สามารถดึงข้อมูลได้ กรุณาติดต่อเจ้าหน้าที่");
                return;
            }
            thisTs.emailAndSmsDetail = sms[0];
            $("#smsHistoryModal").modal('show');
        });
        // this.dtS = $("#tbSMS").dataTable({
        //   retrieve: true,
        //   'paginate': false
        // });
    };
    ContactHistoryComponent.prototype.onForwardTeamChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var tmp;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.agentList.filter(function (a) {
                            return a.dpa_teamidlist.map(function (ag) { return ag.dpa_callcenterteamid; }).indexOf(_this.forwardTeam) > -1;
                        })];
                    case 1:
                        tmp = _a.sent();
                        this.userList = [];
                        tmp.forEach(function (a) {
                            if (_this.userList.indexOf(a) == -1 && a.dpa_customwebuserid != _this.cookieData.userId) {
                                _this.userList.push(a);
                            }
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    ContactHistoryComponent.prototype.getSelectedContact = function () {
        var thisTs = this;
        this.selectList = [];
        $('.row-checker:checkbox:checked').each(function () {
            var value = {
                caseId: $(this).val(),
                customerId: $(this).prop("name"),
                status: $(this).closest('tr').find('td.status')[0].innerHTML
            };
            thisTs.selectList.push(value);
        });
    };
    ContactHistoryComponent.prototype.onCheckAllChange = function () {
        $(".row-checker").prop("checked", this.isCheckedAll);
    };
    ContactHistoryComponent.prototype.save = function (close, closeForward) {
        if (close === void 0) { close = false; }
        if (closeForward === void 0) { closeForward = false; }
        return __awaiter(this, void 0, void 0, function () {
            var caseId;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.newCase.submitted = true;
                        if (!this.newCase.form.valid) return [3 /*break*/, 4];
                        this.util.ShowWaiting(true);
                        if (!this.newCase.isEditMode) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.newCase.updateCase()];
                    case 1:
                        if (_a.sent()) {
                            this.util.ShowWaiting(false);
                            this.util.SuccessDialog("แก้ไขสำเร็จ");
                            if (close) {
                                window.close();
                            }
                            if (closeForward) {
                                $("#forwardModal").modal('hide');
                            }
                        }
                        else {
                            this.util.ErrorDialog("แก้ไขไม่สำเร็จ");
                            this.util.ShowWaiting(false);
                        }
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.createCase()];
                    case 3:
                        caseId = _a.sent();
                        this.newCase.form.controls["incidentid"].setValue(caseId);
                        if (caseId != null) {
                            this.util.ShowWaiting(false);
                            this.util.SuccessDialog("สร้าง Case สำเร็จ");
                            this.newCase.isEditMode = true;
                            if (close) {
                                window.close();
                            }
                            if (closeForward) {
                                $("#forwardModal").modal('hide');
                            }
                        }
                        else {
                            this.util.ErrorDialog("สร้าง Case ไม่สำเร็จ");
                            this.util.ShowWaiting(false);
                        }
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    return ContactHistoryComponent;
}());
export { ContactHistoryComponent };



// WEBPACK FOOTER //
// ./src/app/contact-history/contact-history.component.ts.pre-build-optimizer.js